<template>
  <div>
    <v-app v-if="isIE11()">
      <v-container class="fill-height">
        <v-row>
          <v-col>
            <v-row>
              <v-col>
                <div class="text-h2">
                  Browser not supported!
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <div class="text-h5">
                  Please use one of the following browsers:
                </div>
              </v-col>
            </v-row>
            <v-row justify="space-around">
              <v-col class="text-center" cols="auto">
                <a href="https://www.google.com/chrome/" target="_blank">
                  <v-img :src="require ('@/assets/chrome.png')" max-width="64px"></v-img>
                  Chrome
                </a>
              </v-col>
              <v-col class="text-center" cols="auto">
                <a href="https://www.mozilla.org/firefox/new/" target="_blank">
                  <v-img :src="require ('@/assets/firefox.png')" max-width="64px"></v-img>
                  Firefox
                </a>
              </v-col>
              <v-col class="text-center" cols="auto">
                <a href="https://www.microsoft.com/edge" target="_blank">
                  <v-img :src="require ('@/assets/edge.png')" max-width="64px"></v-img>
                  Edge
                </a>
              </v-col>
              <v-col class="text-center" cols="auto">
                <a href="https://support.apple.com/downloads/safari" target="_blank">
                  <v-img :src="require ('@/assets/safari.png')" max-width="64px"></v-img>
                  Safari
                </a>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-app>
    <router-view v-else/>
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {
    isIE11 ()
    {
      return ( !!window.MSInputMethodContext && !!document.documentMode );
    },
  },
};
</script>
